export const aboutInfo = {
  brandName: '美女视频精选合集',
  tagline: '发现美，传递美，分享美',
  introduction: '美女视频精选合集成立于2024年，是国内领先的高清美女视频内容平台。我们致力于发现和分享来自全国各地的优秀视频内容，涵盖时尚穿搭、生活写真、才艺展示、美容美妆、健身运动、旅行美食等多个领域。平台坚持每日更新，严格筛选每一个视频，为用户提供最优质的视觉体验。我们相信，每个人都有独特的美，而我们的使命就是让这些美被更多人看见。',
  mission: '我们致力于打造一个高品质、多元化的视频内容平台，让每个人都能在这里找到自己喜欢的精彩内容，发现生活中的美丽瞬间。',
  vision: '成为国内最受欢迎的美女视频内容平台，用优质内容连接创作者与观众，共同创造美好的视觉文化生态。',
};

export const testimonials = [
  {
    name: '小雅',
    role: '忠实用户',
    avatar: 'https://readdy.ai/api/search-image?query=Beautiful%20Asian%20woman%20portrait%2C%20professional%20headshot%2C%20warm%20natural%20lighting%2C%20clean%20cream%20background%2C%20friendly%20smile&width=200&height=200&seq=testimonial-01&orientation=squarish',
    content: '每天都在这里刷视频，内容质量真的很高！特别喜欢时尚穿搭板块，学到了很多搭配技巧，现在出门穿搭更有自信了。',
    rating: 5,
  },
  {
    name: '思雨',
    role: 'VIP用户',
    avatar: 'https://readdy.ai/api/search-image?query=Elegant%20Asian%20woman%20portrait%2C%20soft%20smile%2C%20professional%20headshot%2C%20minimalist%20background%2C%20warm%20lighting&width=200&height=200&seq=testimonial-02&orientation=squarish',
    content: '视频画质很清晰，更新也非常及时。才艺展示板块有很多宝藏博主，每次看都能获得灵感。强烈推荐给身边的朋友！',
    rating: 5,
  },
  {
    name: '美琳',
    role: '资深用户',
    avatar: 'https://readdy.ai/api/search-image?query=Pretty%20Asian%20woman%20portrait%2C%20warm%20expression%2C%20professional%20headshot%2C%20cream%20toned%20background%2C%20natural%20lighting&width=200&height=200&seq=testimonial-03&orientation=squarish',
    content: '从平台刚上线就开始关注了，亲眼见证了内容的不断丰富和完善。美容美妆板块的视频教程非常实用，小白也能轻松上手。',
    rating: 5,
  },
  {
    name: '雨桐',
    role: '活跃用户',
    avatar: 'https://readdy.ai/api/search-image?query=Attractive%20Asian%20woman%20portrait%2C%20gentle%20smile%2C%20professional%20headshot%2C%20soft%20background%2C%20clean%20lighting&width=200&height=200&seq=testimonial-04&orientation=squarish',
    content: '旅行美食板块是我的最爱！跟着视频打卡了很多城市的美食，每次都有新发现。感谢平台提供了这么多优质内容！',
    rating: 5,
  },
];

export const milestones = [
  { year: '2024.03', event: '美女视频精选合集正式上线' },
  { year: '2024.06', event: '视频总量突破1000个，日活跃用户突破10万' },
  { year: '2024.10', event: '新增才艺展示和美容美妆分类，内容更加多元' },
  { year: '2025.02', event: '平台累计播放量突破1亿次' },
  { year: '2025.08', event: '视频总量突破8000个，月活跃用户超过500万' },
  { year: '2026.01', event: '全新改版升级，优化观看体验，累计播放突破3亿' },
];

export const contactInfo = {
  email: 'contact@meinvshipin.com',
  wechat: 'meinvshipin2024',
  weibo: '@美女视频精选合集',
  address: '北京市朝阳区建国路88号SOHO现代城A座',
};